<template>
  <footer class="hide-print">
    <hr v-if="hasSite && border" />
    <div :class="['content', { tight }]">
      <span v-if="!hasDefaultSlot">{{ site.footer }}</span>
      <slot></slot>
      <p class="accessibility-link">
        <vue-link to="/accessibility">Accessibility Statement</vue-link>
      </p>
    </div>
  </footer>
</template>

<script>
import PageMixin from '@/mixins/PageMixin'

export default {
  name: 'GlobalFooter',
  mixins: [ PageMixin ],
  props: {
    border: {
      type: Boolean,
      default: false
    },
    tight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>

<style scoped>
footer {
  width: 100%;
}

.content {
  font: var(--nord);
  text-align: center;
  text-transform: uppercase;
  padding: 3rem 2rem 3.5rem 2rem;
}

.content.tight {
  padding-bottom: 2rem;
}

a {
  border-bottom: 1px solid #fff;
}

a:hover {
  border: none;
}

.accessibility-link {
  margin-top: 1rem;
}

@media (max-width: 1000px) {
  .content {
    padding-top: 2.25rem;
    padding-bottom: 2.5rem;
  }
}
</style>